import React from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { useTranslation } from 'react-i18next';
import RBIErrorPopup from './RBIErrorPopup';

interface RBISystemDownModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const RBISystemDownModal: React.FC<RBISystemDownModalProps> = ({
  isOpen,
  onClose,
}) => {
  const { t } = useTranslation();
  const { ramWarningBarToggle } = useFlags();

  const getSystemDownMessage = () => {
    return ramWarningBarToggle
      ? t('operationHours.plannedMaintenance')
      : t('operationHours.unplannedMaintenance');
  };

  return (
    <RBIErrorPopup
      isOpen={isOpen}
      closeModal={onClose}
      message={getSystemDownMessage()}
      messageHeader={t('operationHours.error.headerText')}
      footerText={t('operationHours.selectedRestaurants.ok')}
    />
  );
};

export default RBISystemDownModal;
